module.exports = __webpack_public_path__ + "static/media/machinegunSound.fff7a513.mp3";